import { useState } from "react";
import { useDebounce, useToast } from "../../../shared/hooks";
import { FinancialService } from "../../../shared/services/api/financial/FinancialService";
import { ToastContent } from "../../../shared/components";
import { IInstallmentDetail } from "../types/types";

export const useInstallmentDetails = ({
	dataIni,
	dataFim,
	paymentMethod,
}: {
	dataIni: string;
	dataFim: string;
	paymentMethod: "credit_card" | "billet"; // pode ser extendido futuramente
}) => {
	const [rows, setRows] = useState<IInstallmentDetail[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const { debounce } = useDebounce();
	const toastHandler = useToast();

	const fetchDetails = (clientId: string) => {
		setIsLoading(true);
		debounce(async () => {
			try {
				const response = await FinancialService.getInstallmentbyDocument(1, 10000, clientId, dataIni, dataFim, "Todos", paymentMethod);

				if (response instanceof Error) {
					throw response;
				}

				const formattedData = response.data.map((item) => ({
					...item,
					Installment_number: Number(item.Installment_number),
				}));

				setRows(formattedData);
			} catch (error: any) {
				console.error("Erro ao buscar detalhes:", error.message);
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title="Erro" content="Erro ao buscar os detalhes da cobrança. Por favor, tente novamente." />,
				});
			} finally {
				setIsLoading(false);
			}
		});
	};

	return { rows, isLoading, fetchDetails };
};
